import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  background = input<string>('#222');
  text = input<string>('#ffffff');
  showPaymentImages = input<boolean>(false);
  /**
   * Left unset by default so the stylesheet's own responsive rule applies
   * (fixed on desktop, static on mobile — see footer.component.scss). Only
   * pass this in to force a specific position regardless of screen size.
   */
  position = input<string | null>(null);
  currentYear = new Date().getFullYear();

  openTCs() {
    window.open('https://thelightuphub.com/terms-and-conditions', '_blank');
  }

  openPrivacyPolicy() {
    window.open('https://thelightuphub.com/privacy-policy', '_blank');
  }
}
